import { render, staticRenderFns } from "./StoryPreviewCardActions.vue?vue&type=template&id=68bfb85f&scoped=true&"
import script from "./StoryPreviewCardActions.vue?vue&type=script&lang=js&"
export * from "./StoryPreviewCardActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bfb85f",
  null
  
)

export default component.exports